<template>
<div class="d-lottie-success">
    <DLottie @complete="complete" @loaded="loaded" :size="size" :autoplay="autoplay" :loop="loop" :src="success_src"></DLottie>
</div>
</template>

    
<script setup>

import { defineProps, defineEmits } from 'vue';
const emit = defineEmits(['complete', 'loaded'])

import DLottie from './LottieComponent.vue'
import lootieicons from '../../enums/dlottie';

const props = defineProps({
    size: { type: Number},
    loop: { type: Boolean, default: false },
    autoplay: { type: Boolean, default: true },
    name :{ type:String, default: "default"},
    link: { type: String, default: null}
})  

const success_src = props.link ? props.link : JSON.parse(lootieicons.success[props.name]);

function complete(){
    emit("complete");
}

function loaded(){
    emit("loaded");
}
</script>
